"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withReactNativeNavigation = void 0;
var _reactNative = require("react-native");
var _OptionalReactNativeNavigationWix = require("../optional/OptionalReactNativeNavigationWix");
var withReactNativeNavigation = function withReactNativeNavigation(posthog) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!_OptionalReactNativeNavigationWix.OptionalReactNativeNavigationWix) {
    return false;
  }
  var Navigation = _OptionalReactNativeNavigationWix.OptionalReactNativeNavigationWix.Navigation;
  var trackLifecycle = function trackLifecycle() {
    var _a;
    if (!((_a = options.captureLifecycleEvents) !== null && _a !== void 0 ? _a : true)) {
      return;
    }
    posthog.capture('Application Opened');
    _reactNative.AppState.addEventListener('change', function (nextAppState) {
      switch (nextAppState) {
        case 'active':
          return posthog.capture('Application Became Active');
        case 'background':
          return posthog.capture('Application Backgrounded');
        default:
          return;
      }
    });
  };
  trackLifecycle();
  Navigation.events().registerComponentDidAppearListener(function (_ref) {
    var componentName = _ref.componentName,
      passProps = _ref.passProps;
    var _a, _b, _c, _d, _e;
    if (!((_a = options.captureScreens) !== null && _a !== void 0 ? _a : true)) {
      return;
    }
    var currentRouteName = ((_c = (_b = options === null || options === void 0 ? void 0 : options.navigation) === null || _b === void 0 ? void 0 : _b.routeToName) === null || _c === void 0 ? void 0 : _c.call(_b, componentName, passProps || {})) || componentName || 'Unknown';
    if (currentRouteName) {
      var properties = (_e = (_d = options === null || options === void 0 ? void 0 : options.navigation) === null || _d === void 0 ? void 0 : _d.routeToProperties) === null || _e === void 0 ? void 0 : _e.call(_d, currentRouteName, passProps || {});
      posthog.screen(currentRouteName, properties);
    }
  });
  return true;
};
exports.withReactNativeNavigation = withReactNativeNavigation;